import React from 'react';

import { withScreenWidget } from '@gogame/screens';

import HourlyTrackerChartsSlider from 'scenes/Trackers/HourlyTracker/components/HourlyTrackerCharts/HourlyTrackerChartsSlider';
import { hourlyTrackerReducer } from 'scenes/Trackers/HourlyTracker/reducers';

import HourlyTrackerPresetActions from './Actions';
import HourlyTrackerPresetDescription from './Description';
import HourlyTrackerPresetFilters from './Filters';
import HourlyTrackerPresetStorage from './Storage';

export const HourlyTrackerWidget = withScreenWidget({
  title: 'Hourly Tracker',
  name: 'ad-tracker',
  reducer: hourlyTrackerReducer,
  storage: <HourlyTrackerPresetStorage />,
  description: <HourlyTrackerPresetDescription />,
  filters: <HourlyTrackerPresetFilters />,
  actions: <HourlyTrackerPresetActions />,
})(({ tooltipPosStrategy }) => (
  <HourlyTrackerChartsSlider tooltipPosStrategy={tooltipPosStrategy} />
));

export default HourlyTrackerWidget;
